module.exports = __webpack_public_path__ + "img/mv7.7352df9a.png";